import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  clearSessionButtonVariant: 'primary',
  showClearSessionButton: true
} satisfies RecursivePartial<CheckoutConfig['buyInStore']>
